import { create } from 'zustand';

import { LocaleType, LabelsType } from '../@types';

type State = {
  lang: LocaleType,
  stripeTheme: Record<string, any> | undefined,
  labels?: Record<string, any> | undefined,
  propertyId: number | undefined,
  apiKey: string | undefined,
}

type Action = {
  setStripeTheme: (theme: Record<string, any>) => void,
  setLang: (lang: LocaleType) => void,
  setLabels: (labels: LabelsType) => void,
  setPropertyId: (pid: number) => void,
  setApiKey: (apiKey: string) => void,
}

export const useCommonOptionsStore = create<State & Action>()(set => ({
  lang: 'en',
  stripeTheme: undefined,
  propertyId: undefined,
  apiKey: undefined,
  labels: undefined,
  setLang: (lang: string) => set(() => ({ lang })),
  setLabels: labels => set(() => ({ labels })),
  setStripeTheme: (theme: any) => set(() => ({ stripeTheme: theme })),
  setPropertyId: (propertyId: number) => set(() => ({ propertyId })),
  setApiKey: (apiKey: string) => set(() => ({ apiKey })),
}));
